import { Injectable } from '@angular/core';

import { UserRole } from '../models/skill-learning.model';

const USER_STORAGE_KEY = 'User';

@Injectable()
export class SkillRoleService {

  private fetchUserRoles(): string[] {
    const raw = localStorage.getItem(USER_STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const user = JSON.parse(raw);
    if (!user || !user.roles) {
      return [];
    }
    return user.roles as string[];
  }

  private hasRole(role: UserRole): boolean {
    return this.fetchUserRoles().indexOf(role) !== -1;
  }

  isAdmin(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }

  isHeadOrAdmin(): boolean {
    return this.hasRole('ROLE_HEAD') || this.isAdmin();
  }

  isSpecializationAdmin(): boolean {
    return this.hasRole('ROLE_ADMIN_SPECIALIZATION') || this.isHeadOrAdmin();
  }

  canCreateSpecialization(): boolean {
    return this.isSpecializationAdmin();
  }

  isRegularUser(): boolean {
    return this.hasRole('ROLE_USER');
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-role.service.ts